import { Component, Inject, OnInit } from '@angular/core';
import { DetalleAmortizacion } from '../../../utils/perfil.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-detalle-armoticacion-modal',
  templateUrl: './detalle-armoticacion-modal.component.html',
  styleUrls: ['./detalle-armoticacion-modal.component.scss']
})
export class DetalleArmoticacionModalComponent implements OnInit {

  displayedColumns = [
    'numeroCuota',
    'capital',
    'interes',
    'seguro',
    'valorCuota',
    'saldoCapital'
  ];

  dataSource = new MatTableDataSource<DetalleAmortizacion>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { detalle: DetalleAmortizacion[] }
  ) { 
    this.dataSource.data = data.detalle;
  }

  ngOnInit(): void {
    console.log('Detalle recibido:', this.data.detalle);
  }
}
